import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLearnMore() {
  const [items, setItems] = useState([]);
  const [drafts, setDrafts] = useState({});
  const [busy, setBusy] = useState(null);
  const load = () => api.get("/admin/learn-more").then((r) => {
    setItems(r.data.items);
    setDrafts((d) => Object.fromEntries(r.data.items.map((i) => [i.area, d[i.area] ?? i.script])));
  });
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!items.some((i) => i.status === "recording")) return;
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [items]);

  const save = async (area) => {
    setBusy(area);
    try { const { data } = await api.put(`/admin/learn-more/${area}`, { script: drafts[area] || "" }); setItems(data.items); toast.success(drafts[area] ? "Saved — recording Adelaida's voice once." : "Cleared."); }
    catch { toast.error("Couldn't save."); } finally { setBusy(null); }
  };

  return (
    <section className="mt-12" data-testid="admin-learn-more">
      <h2 className="font-serif text-3xl mb-2">Learn more · Adelaida explains</h2>
      <p className="text-muted-foreground mb-6 max-w-xl">Write what Adelaida says for each Reclaim area. Saving records her voice once — every play after that is free.</p>
      <div className="space-y-6">
        {items.map((i) => (
          <div key={i.area} className="glass rounded-2xl p-5 border border-white/10" data-testid={`admin-learn-${i.area}`}>
            <div className="flex items-center justify-between mb-2">
              <b>{i.title}</b>
              <span className="text-xs text-muted-foreground" data-testid={`admin-learn-status-${i.area}`}>
                {i.status === "ready" ? "Recorded" : i.status === "recording" ? "Recording…" : i.status === "failed" ? i.error : "No script yet"}
              </span>
            </div>
            <Textarea rows={5} value={drafts[i.area] || ""} onChange={(e) => setDrafts((d) => ({ ...d, [i.area]: e.target.value }))}
              placeholder={`What Adelaida says about ${i.title}…`} data-testid={`admin-learn-script-${i.area}`} />
            <div className="flex items-center gap-3 mt-3">
              <Button size="sm" className="rounded-full" onClick={() => save(i.area)} disabled={busy === i.area || i.status === "recording" || ((drafts[i.area] || "") === i.script && i.status === "ready")} data-testid={`admin-learn-save-${i.area}`}>Save &amp; record</Button>
              {i.audio_url && <audio controls src={`${BACKEND_URL}${i.audio_url}`} className="h-8" />}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
